import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'get'

export default class OspreyOffersUniqueName extends BaseAction {
    constructor(dataKey) {
        const id = '1e1ca48a-47a1-5d2f-a720-9fd03b36f3c8'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getOffersUniqueName(params) {
        this.params = params

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-unique-name.js